import React from 'react';

import { buildClassNames } from '../../utils';

import './index.scss';

export const Label: React.FC<React.ComponentProps<'label'>> = ({ className, ...props }) => {
  const classNames = buildClassNames('chron__label', className);
  return <label className={classNames} {...props} />;
};
